// Class: starling.utils.MeshSubset

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;

// Constructor

var MeshSubset = function(vertexID,numVertices,indexID,numIndices) {
	if(numIndices == null) {
		numIndices = -1;
	}
	if(indexID == null) {
		indexID = 0;
	}
	if(numVertices == null) {
		numVertices = -1;
	}
	if(vertexID == null) {
		vertexID = 0;
	}
	this.setTo(vertexID,numVertices,indexID,numIndices);
}

// Meta

MeshSubset.__name__ = ["starling","utils","MeshSubset"];
MeshSubset.prototype = {
	setTo: function(vertexID,numVertices,indexID,numIndices) {
		if(numIndices == null) {
			numIndices = -1;
		}
		if(indexID == null) {
			indexID = 0;
		}
		if(numVertices == null) {
			numVertices = -1;
		}
		if(vertexID == null) {
			vertexID = 0;
		}
		this.vertexID = vertexID;
		this.numVertices = numVertices;
		this.indexID = indexID;
		this.numIndices = numIndices;
	}
};
MeshSubset.prototype.__class__ = MeshSubset.prototype.constructor = $hxClasses["starling.utils.MeshSubset"] = MeshSubset;

// Init



// Statics




// Export

exports.default = MeshSubset;


//////////////////
// WEBPACK FOOTER
// ./lib/_gen/starling/utils/MeshSubset.js
// module id = 62
// module chunks = 0